<template>
<div>
  <NotificationTooltipHeader @clearNotification="clearNotification"/>
  <div class="header-notifications-window" @scroll="scrollNotification">
    <div class="header-notifications-list">
      <NotificationItem v-for="notification in notifications" :notification="notification" :key="notification.idNotification"></NotificationItem>
    </div>
  </div>
</div>
</template>

<script>
import NotificationTooltipHeader from "@/components/notification/NotificationTooltipHeader";
import NotificationItem from "@/components/notification/NotificationItem";
import api from "@/api/notification";
export default {
name: "NotificationTooltipWrapper",
components: {NotificationItem, NotificationTooltipHeader},
computed: {
  notifications() {
    return this.$store.getters.notificationByCompany
  }
},
methods: {
  clearNotification() {
    this.notifications.forEach((notification) => {
      api.deleteNotification(notification.idUserNotification, () => {
        this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
      })
    })
  },
  scrollNotification() {
    if (document.querySelector('.header-notifications-window').scrollTop + document.querySelector('.header-notifications-window').offsetHeight >= document.querySelector('.header-notifications-list').offsetHeight) {
      document.querySelector('.header-notifications .tooltip-bubble-inner').classList.add('bottom-visible')
    } else {
      document.querySelector('.header-notifications .tooltip-bubble-inner').classList.remove('bottom-visible')
    }
  }
}
}
</script>

<style scoped>

</style>